import { render, staticRenderFns } from "./BatchPathologists.vue?vue&type=template&id=42178e7b&scoped=true&"
import script from "./BatchPathologists.vue?vue&type=script&lang=js&"
export * from "./BatchPathologists.vue?vue&type=script&lang=js&"
import style0 from "./BatchPathologists.vue?vue&type=style&index=0&id=42178e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42178e7b",
  null
  
)

export default component.exports